import { observer } from "mobx-react";
import ProfileStore from ".";
import { ProfileState } from "./Types";
import { ProfileResource } from "./Types";
import { AxiosResponse, AxiosError } from "axios";
import BaseReaction, { BaseReactionProps } from "../../BaseReaction";
import { getRequest } from "../../utils/httpRequest";
import { isLoggedIn } from "../../utils/session";

interface State {
  state: ProfileState;
}

export interface Props extends BaseReactionProps<ProfileStore> {
  store: ProfileStore;
}

class ProfileReactions extends BaseReaction<ProfileStore, State, Props> {
  tester = (): State => ({
    state: this.props.store.state
  });

  effect = ({ state }: State) => {
    const { store } = this.props;
    switch (state.kind) {
      case "loading":
        // There is no profile to fetch for a signed-out visitor: the endpoint
        // answers with an empty body, which resolved the store into a "ready" state
        // holding nothing. The profile UI is only reachable once signed in, so
        // leaving the store unresolved here costs nothing and saves the round trip.
        if (!isLoggedIn()) {
          break;
        }

        getRequest("/api/profile.json")
          .then((response: AxiosResponse<ProfileResource>) => {
            const { data } = response;

            this.props.store.ready(data);
          })
          .catch((error: AxiosError) => {
            console.log(error.response?.statusText);
          });
        break;

      case "waiting":
      case "ready":
        break;
    }
  };
}

export default observer(ProfileReactions);
